import { useCallback } from 'react'
import { useParams } from 'react-router'

import { useBalanceConfig, useBalanceLabels } from '@features/balanceLedger'
import type { BalanceExportFormat } from '@features/balanceLedger/types/balanceExport'
import { useExpertReportPeriod } from '@features/expertReports'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useExportFileDownload } from './useExportFileDownload'
import { useLedgerEntriesFilters } from './useLedgerEntriesFilters'

interface UseDownloadCreditorBalanceStatementExportResult {
  downloadExport: (format: BalanceExportFormat) => Promise<void>
  isExporting: boolean
}

export const useDownloadCreditorBalanceStatementExport = (): UseDownloadCreditorBalanceStatementExportResult => {
  const config = useBalanceConfig()
  const { bt } = useBalanceLabels()
  const { organization } = useUserOrganization()
  const { id: contactId } = useParams<{ id: string }>()
  const { encodedPeriod } = useExpertReportPeriod()
  const [{ ledgerSearchQuery }] = useLedgerEntriesFilters()

  const fetchExport = useCallback(
    (format: BalanceExportFormat) =>
      config.fetchStatementExport({
        organizationId: organization?.id ?? '',
        contactId: contactId ?? '',
        format,
        period: encodedPeriod,
        search: ledgerSearchQuery,
      }),
    [config, contactId, encodedPeriod, ledgerSearchQuery, organization?.id],
  )

  return useExportFileDownload({
    fetchExport,
    isReady: !!organization?.id && !!contactId,
    notificationKey: config.exportNotificationKey,
    errorMessage: bt('export.error'),
  })
}
